import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-12 flex items-center">
                <img 
                  src="/ZihniLogoNeu.png" 
                  alt="Logo"
                  className="h-12 w-auto object-contain brightness-0 invert"
                />
              </div>
              <div className="text-white font-bold text-lg">{companyInfo.name}</div>
            </div>
            <p className="text-sm text-gray-400">
              Ihr unabhängiger Partner für professionelle Kfz-Gutachten. Objektiv, transparent und zuverlässig.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-forest-400 transition-colors">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/leistungen" className="text-sm hover:text-forest-400 transition-colors">
                  Leistungen
                </Link>
              </li>
              <li>
                <Link to="/werte" className="text-sm hover:text-forest-400 transition-colors">
                  Unsere Werte
                </Link>
              </li>
              <li>
                <Link to="/arbeitsweise" className="text-sm hover:text-forest-400 transition-colors">
                  Arbeitsweise
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm hover:text-forest-400 transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-forest-400 flex-shrink-0 mt-0.5" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm hover:text-forest-400 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-forest-400 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm hover:text-forest-400 transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-forest-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} {companyInfo.name}. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              <Link to="/impressum" className="text-sm text-gray-400 hover:text-forest-400 transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-sm text-gray-400 hover:text-forest-400 transition-colors">
                Datenschutz
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
